module.exports = __webpack_public_path__ + "static/media/cert_4997.2e9dde66.jpg";